module.exports = __webpack_public_path__ + "staticcomp/img/top.c552ec2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/11/top.jpg
// module id = jEbw
// module chunks = 39